<template>
  <div>
    <meta name="csrf-token" content="{{ csrf_token() }}" />
    <menubar />
    <div class="container">
      <div class="title-btn d-flex justify-content-between align-items-center">
        <div id="title" class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">チーム詳細</p>
        </div>
      </div>

      <div class="d-flex mb-3">
        <div class="me-4">
          <span>社名・組織名</span>
          <span class="badge display-user mx-1">{{ name }}</span>
        </div>
        <div class="me-4">
          <!-- 3月時点のデザインだとメンバー数，仕様だとチーム数．どっちが正解？ -->
          <span>メンバー数</span>
          <span class="badge display-user mx-1">{{ memberCount }}</span>
        </div>
        <div>
          <span>管理者</span>
          <span class="badge display-user mx-1">{{ admin }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">作成(or更新)日: {{ showLocalDate(updated_at, "/") }}</div>
      </div>
      <div class="row">
        <div class="col-md-12">特徴：{{ description }}</div>
      </div>

      <div class="subtitle-row d-flex justify-content-between">
        <div>
          <h2>チームメンバー一覧</h2>
        </div>
        <div>
          <modal ref="addMemberModal">
            <template v-slot:activator="{ openModal }">
              <button
                class="btn btn-purple show-modal"
                @click="openAddMemberModal"
              >
                メンバー追加
              </button>
            </template>

            <template v-slot:modalTitle> 追加可能なユーザー一覧 </template>
            <template v-slot:modal-content="{ closeModal }">
              <div class="w-75 mb-2 input-group">
                <input
                  type="text"
                  class="form-control border-end-0 border"
                  v-model="searchText"
                  placeholder="ユーザー名かメールアドレスを入力して検索"
                />
                <span class="input-group-append">
                  <button
                    class="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border ms-n5"
                    style="margin-left: -40px"
                    type="button"
                  >
                    <img src="/img/25_search.svg" style="width: 20px" />
                  </button>
                </span>
              </div>
              <table class="table component_table">
                <thead>
                  <tr>
                    <th scope="col" class="text-center">No</th>
                    <th scope="col" class="text-center">ユーザー名</th>
                    <th scope="col" class="text-center">メールアドレス</th>
                    <th scope="col" class="text-center">権限</th>
                    <th scope="col" class="text-center">追加</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in filteredUsers" :key="index">
                    <td class="align-middle text-center">
                      {{ index + 1 }}
                    </td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.authority }}</td>
                    <td class="align-middle text-center">
                      <input
                        type="checkbox"
                        v-model="addedUsers"
                        :value="user.id"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="modal-btn d-flex justify-content-center">
                <button
                  class="btn btn-purple"
                  @click="
                    closeModal();
                    addUsers();
                  "
                >
                  追加
                </button>
              </div>
            </template>
          </modal>
        </div>
      </div>

      <table class="table component_table">
        <thead>
          <tr>
            <th scope="col" class="text-center">No</th>
            <th scope="col" class="text-center">ユーザー名</th>
            <th scope="col" class="text-center">メールアドレス</th>
            <th scope="col" class="text-center">権限</th>
            <th scope="col" class="text-center">備考</th>
            <th scope="col" class="text-center">編集</th>
            <th scope="col" class="text-center">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(member, index) in members" :key="index">
            <td class="align-middle text-center">{{ index + 1 }}</td>
            <td class="align-middle">
              <span
                class="badge invited-user"
                v-show="showUserInvited(member.status)"
                >{{ member.status }}</span
              >{{ member.name }}
            </td>
            <td class="align-middle">{{ member.email }}</td>
            <td class="align-middle">{{ member.authority }}</td>
            <td class="align-middle">{{ member.remark }}</td>
            <td class="align-middle table-icon">
              <modal>
                <template v-slot:activator="{ openModal }">
                  <div class="text-center">
                    <img
                      src="/img/17_edit.svg"
                      alt="編集画面へ"
                      @click="
                        openModal();
                        setMemberEditFormDefault(member);
                      "
                    />
                  </div>
                </template>

                <template v-slot:modalTitle> ユーザー編集 </template>
                <template v-slot:modal-content="{ closeModal }">
                  <div>
                    <div class="mb-4">
                      <label class="form-label"
                        >ユーザー名<span
                          class="mx-2 badge rounded-pill bg-danger"
                          >必須</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="entryName"
                      />
                    </div>

                    <div class="mb-4">
                      <label for="exampleInputEmail1" class="form-label"
                        >メールアドレス<span
                          class="mx-2 badge rounded-pill bg-danger"
                          >必須</span
                        ></label
                      >
                      <input
                        type="email"
                        class="form-control"
                        id="exampleInputEmail1"
                        v-model="entryEmail"
                      />
                    </div>

                    <div class="mb-4">
                      <label class="form-label"
                        >権限<span class="mx-2 badge rounded-pill bg-danger"
                          >必須</span
                        ></label
                      >
                      <select class="form-select" v-model="entryAuthority">
                        <option>オーナー</option>
                        <option>マネージャー</option>
                        <option>メンバー</option>
                        <option>ゲスト</option>
                      </select>
                    </div>

                    <div class="mb-4">
                      <label for="entryRemark" class="form-label">備考</label>
                      <input
                        type="text"
                        class="form-control"
                        id="entryRemark"
                        v-model="entryRemark"
                      />
                    </div>
                  </div>
                  <input type="hidden" name="_token" :value="csrf" />

                  <div class="modal-btn d-flex justify-content-evenly">
                    <button class="btn btn-red" @click="closeModal()">
                      キャンセル
                    </button>
                    <button
                      class="btn btn-purple"
                      @click="
                        closeModal();
                        submitMemberEdit(index);
                      "
                    >
                      変更
                    </button>
                  </div>
                </template>
              </modal>
            </td>
            <td class="align-middle text-center">
              <input
                type="checkbox"
                v-model="deletedMembers"
                :value="member.id"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-red"
          style="font-size: 0.9rem"
          @click="deleteMembers"
        >
          削除
        </button>
      </div>

      <div class="menu">
        <input type="checkbox" id="menu_bar01" />
        <div class="subtitle-row d-flex justify-content-start">
          <h2>用語集</h2>
          <label for="menu_bar01"></label>
        </div>
        <div id="links01" class="menu-content">
          <table class="gls-tbl table component_table">
            <thead>
              <tr>
                <th class="th--gls-name">用語集</th>
                <th class="th--language-pair">言語ペア</th>
                <th class="th--gls-remark">備考</th>
                <th class="th--number">登録<br />チーム数</th>
                <th class="th--number">登録<br />単語数</th>
                <th class="th--user-name">作成者</th>
                <th class="th--date">更新日</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(glossary, index) in glossaries" :key="index">
                <td class="td--gls-name"> {{glossary.name}}</td>
                <td>
                  {{ glossary.src_language_code }}
                  →
                  {{ glossary.trg_language_code }}
                </td>
                <td class="td--gls-remark">{{ glossary.remark }}</td>
                <td>{{ glossary.number_of_teams }}</td>
                <td>{{ glossary.number_of_pairs }}</td>
                <td>{{ glossary.user.name }}
                  <div v-if="glossary.user.deleted_at != null" >(削除済み)</div>
                </td>

                <td>{{ showLocalDate(glossary.updated_at, "-") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import modal from "@/Pages/Components/modal.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import showLocalDate from '@/Pages/Components/showLocalDate.js';

export default defineComponent({
  components: {
    menubar,
    modal,
    footerComponent,
  },
  props: {
    id: Number,
    name: String,
    admin: String,
    description: String,
    memberCount: Number,
    members: Array,
    users: Array,
    glossaries: Array,
    aiModels: Array,
    updated_at: String,
    csrfToken: String,
    glossaries: Object,
    trainableAimodels: Object,
    clientAimodels: Object,
  },
  data() {
    return {
      addedUsers: [],
      deletedMembers: [],
      entryName: "",
      entryEmail: "",
      entryAuthority: "",
      entryTeamName: "",
      entryAdministrator: 1,
      entryRemark: "",
      allClickedCheck: false,
      onEditer: false,
      newModel: "",
      exp_link: "//",
      isOpen: false,
      isRireki: false,
      checkedModel: ["---", "", ""],
      limitNumModel: 5,
      onCreating: false,
      isPopUp: [false, false, false],
      offCreating: false,
      removeModel: [],
      isChecked: [],
      editModel: "",
      edit_target: null,
      teams: ["Aチーム", "Bチーム", "Cチーム"],
      parent_models: [
        {
          no: "親",
          model: "JVTA Ver1.1",
          team: "",
          lang_pair: "英→日",
          parent_model: "----",
          isOld: true,
          creating_date: "2022/03/27",
          administer: "----",
          learning_amount: "",
          lerning_log: [],
          ver: "Ver1.1",
        },
        {
          no: "親",
          model: "JVTA Ver1.2",
          team: "",
          lang_pair: "英→日",
          parent_model: "----",
          isOld: false,
          creating_date: "2022/03/28",
          administer: "----",
          learning_amount: "",
          lerning_log: [],
          ver: "Ver1.2",
        },
        {
          no: "親",
          model: "JVTA Ver1.3",
          team: "",
          lang_pair: "英→日",
          parent_model: "----",
          isOld: false,
          creating_date: "2022/03/30",
          administer: "----",
          learning_amount: "",
          lerning_log: [],
          ver: "Ver1.3",
        },
      ],
      child_models: [
        {
          no: 1,
          model: "映画SF(字幕)",
          team: ["Aチーム"],
          lang_pair: "英→日",
          parent_model: "JVTA Ver1.1",
          creating_date: "2022/8/15",
          administer: "富岡 修",
          learning_amount: "XXXXX",
          lerning_log: [],
          team_n: 1,
          isOld: true,
          ver: "Ver1.1",
          rireki: [
            {
              name: "The Matrix Resurrections",
              date: "2022/02/13",
              status: "予約中",
            },
            {
              name: "The Matrix Revolutions",
              date: "2022/02/5",
              status: "実施中",
            },
            {
              name: "The Matrix 大全",
              date: "2022/10/11",
              status: "終了（学習済み）",
            },
          ],
        },
        {
          no: 2,
          model: "映画SF(吹き替え)",
          team: ["Aチーム", "Bチーム"],
          lang_pair: "英→日",
          parent_model: "映画SF(字幕)",
          creating_date: "2022/8/ 20",
          team_n: 2,
          administer: "加納 保昌",
          learning_amount: "XXXXX",
          lerning_log: [],
          isOld: true,
          ver: "Ver1.1",
          rireki: [
            {
              name: "The Matrix Resurrections",
              date: "2022/02/13",
              status: "予約中",
            },
            {
              name: "The Matrix Revolutions",
              date: "2022/02/5",
              status: "実施中",
            },
            {
              name: "The Matrix 大全",
              date: "2022/10/11",
              status: "終了（学習済み）",
            },
          ],
        },
        {
          no: 3,
          model: "映画SF",
          team: ["Aチーム", "Cチーム"],
          lang_pair: "英→日",
          parent_model: "JVTA Ver1.2",
          creating_date: "2022/8/30",
          administer: "加納 保昌",
          team_n: 2,
          learning_amount: "XXXXX",
          lerning_log: [],
          isOld: false,
          ver: "Ver1.2",
          rireki: [
            {
              name: "The Matrix Resurrections",
              date: "2022/02/13",
              status: "予約中",
            },
            {
              name: "The Matrix Revolutions",
              date: "2022/02/5",
              status: "実施中",
            },
            {
              name: "The Matrix 大全",
              date: "2022/10/11",
              status: "終了（学習済み）",
            },
          ],
        },
      ],
      numOfModel: 3,
      max_team: 5,
      searchText: "",
      selectedAimodelTab: '学習済み', // '予約中'
    };
  },
  computed: {
    csrf() {
      // Vuex未使用ならこのように定義
    },
    filteredUsers: function() {
      const users = this.$props.users.filter(user =>   
        user.name.includes(this.searchText) || user.email.includes(this.searchText)
      );
      return users;
    },
  },
  methods: {
    showLocalDate: function (date, separator) {
      return showLocalDate.showLocalDate(date, separator);
    },
    openAddMemberModal: function () {
      this.$refs.addMemberModal.openModal({ is_long: true });
    },
    showUserInvited(status) {
      if (status == "招待中") {
        return true;
      } else {
        return false;
      }
    },
    /**
     * モーダルで指定されたユーザを送信する
     */
    addUsers() {
      if (this.addedUsers.length === 0){
          alert('チームに追加するユーザーを選択してください。');
          return ;
        }
      axios
        .put(
          "/teams/" + this.id + "/users/" + this.addedUsers.join(','),
          {},
          {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrfToken,
            },
          }
        )
        .then((response) => {
            alert("チームにユーザーを追加しました");
            location.reload();
        })
        .catch((error) => {
          alert("ユーザーの追加に失敗しました");
        });
    },
    /**
     * メンバー情報更新時の各フォーム値が有効な値か判定する
     */
    isValidMemberForm() {
      if (!this.entryName) {
        alert("氏名を入力してください");
        return false;
      }
      if (!this.entryEmail) {
        // TODO メールアドレスの書式をチェック, 登録済みメールアドレスを弾くとか？
        alert("メールアドレスを入力してください");
        return false;
      }
      if (!this.entryAuthority) {
        alert("権限を選択してください");
        return false;
      }

      return true;
    },
    /**
     * 編集フォームのデフォルト値にメンバの情報を設定する
     * ※メンバ：既にチームに所属しているユーザ
     * @param {*} member
     */
    setMemberEditFormDefault(member) {
      this.entryName = member.name;
      this.entryEmail = member.email;
      this.entryAuthority = member.authority;
      this.entryRemark = member.remark;
    },
    /**
     * メンバの編集結果をバックエンドに反映する処理
     * @param {propsで渡されるmembersの配列番号} index
     */
    submitMemberEdit(index) {
      if (!this.isValidMemberForm()) {
        return;
      }
      const id = this.members[index].id;
      const member = {
        name: this.entryName,
        email: this.entryEmail,
        authority: this.entryAuthority,
        comment: this.entryRemark, // TODO remarkじゃなくてcommentでいいの？
      };

      axios
        .put("/users/" + id, member, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-CSRF-TOKEN": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
        })
        .then((response) => {
          if (response.status === 204) {
            location.reload();
          }
        })
        .catch((error) => {
            alert(error.response.data.message);
        });
    },
    /**
     * バックエンドに指定されたユーザidを渡して全て削除
     */
    deleteMembers() {
      if (
        window.confirm("チームからユーザーを削除しますが、よろしいですか？")
      ) {
        if (this.deletedMembers.length === 0){
          alert('チームから削除するユーザーを選択してください。');
          return;
        }
        if (this.deletedMembers.length === this.members.length){
          alert('チームの所属ユーザーを0人にすることはできません。');
          return;
        }
        axios
          .delete("/teams/" + this.id + "/users/" + this.deletedMembers.join(','), {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "X-CSRF-TOKEN": this.csrfToken,
            },
          })
          .then((response) => {
            alert("ユーザーを削除しました");
            location.reload();
          })
          .catch((error) => {
            console.dir(error);
            alert(error.response.data.error_message);
          });
      }
    },
    selectAimodelTab: function (value){
      this.selectedAimodelTab = value;
    },
  },
});
</script>

<style lang="scss" scoped>
.container {
  min-height: 80vh;
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  thead {
    white-space: nowrap;
  }
  tbody {
    border-top: 0;
  }
}

.table-icon img {
  width: 1.5rem;
}
.title-row,
.text-end {
  padding: 0 0 1rem 0;
}
.text-end {
  justify-content: flex-end;
}
.display-user {
  background: #aaaaaa;
}
.invited-user {
  background: #a07abe;
  font-size: 0.7rem;
  font-weight: 400;
  vertical-align: text-bottom;
}
.subtitle-row {
  margin: 2rem 0 1rem 0;
}
.footer-component {
  position: inherit;
  bottom: auto;
}
.base_tr {
  text-align: center;
  background-color: #e4e4e3;
}
.select_check {
  float: right;
  padding: 0;
}
.select_each_box {
  padding: 0 10px;
}
.each_model {
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.each_model:hover {
  background-color: #b1eeff;
}
.modalBoard {
  color: #666666;
  font-size: large;
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(1, 1, 1, 0.8);
}
.modalCreating {
  border: solid black 1px;
  width: 60%;
  /* height: 400px; */
  background: white;
  margin: 50px auto;
}
.selectbox {
  width: 100%;
  display: block;
  margin: 10px 0;
}
.selecter {
  width: 100%;
  height: 100px;
  overflow: auto;
  display: block;
  margin: 10px 0;
  border: solid black 1px;
}
.modelSelecter {
  width: 100%;
  border: solid black 1px;
  margin: 10px 0;
}

.popupdate {
  padding: 5px;
  width: 200px;
  top: -70px;
  left: 30px;
  border: solid black 1px;
  background: white;
  position: absolute;
  font-size: xx-small;
}

/* アラート */
.batsu {
  float: right;
  font-size: 100%; /*ボタンの大きさ*/
  font-weight: bold;
  border: 1px solid #999;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  width: 1.3em;
  line-height: 1.3em;
  cursor: pointer;
  transition: 0.2s;
}
.batsu:hover {
  background: #333;
  border-color: #333;
  color: #fff;
}
.popUpError {
  position: absolute;
  right: 110px;
  bottom: 5px;
  color: red;
  font-size: small;
}

.table-wrapper {
  color: #666666;
  font-size: smaller;
  margin: 20px 0 0 0;
}
.table-css {
  width: 100%;
}
td,
th {
  border-width: 1px;
}
.btn-reject {
  width: 70px;
  float: right;
}
.btn-create {
  width: 100px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.title {
  font-size: xx-large;
  margin: 0 0 0 20px;
  font-weight: lighter;
  color: black;
}
.red_color {
  color: red;
}
.modal_title {
  background: #a07abe;
  font-size: x-large;
  padding: 10px;
  color: white;
}
.exp {
  float: right;
  cursor: pointer;
}
.wrapper_content {
  padding: 20px;
}
.p1 {
  font-size: smaller;
  margin: 0;
}
.p2 {
  font-size: x-large;
}
.log_table {
  width: 100%;
}
.column {
  float: right;
  padding: 9px 0 0 4px;
}
.select-mark {
  display: block;
  width: 30px;
}
.oc_column {
  height: 100px;
  border-top: solid 1px black;
  overflow: auto;
  clear: both;
}
.btn-cans {
  width: 110px;
  margin-right: 30px;
}
.btn-add {
  width: 110px;
}
.btn-and-btn {
  text-align: center;
}
.m1-contents {
  position: relative;
}
.slash {
  width: 15px;
  position: absolute;
  bottom: 3px;
}
.model-name {
  position: relative;
  text-decoration: underline;
  cursor: pointer;
  img {
    width: 1.2rem;
    margin-right: 0.3rem;
    vertical-align: text-top;
  }
}
.add-log {
  cursor: pointer;
}
.check-reject {
  margin: 0 auto;
  display: block;
}
.btn-save {
  width: 110px;
}
.w-reject {
  padding: 20px 0 0 0;
}
.inner-seb {
  border-right: solid 1px black;
  float: left;
  width: calc(100% - 40px);
  padding: 1px;
  height: 30px;
}
.inner-box {
  height: 30px;
}

/*アコーディオン全体*/
.menu {
  width: 100%;
}
.menu input {
  display: none; /*チェックボックスを隠す*/
}
/*バー部分*/
.menu label {
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  line-height: 1;
  position: relative;
  margin: 0 0 10px;
  padding: 10px;
}
/*開いたときに表示される部分*/
.menu-content {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-bottom: 1px;
}
.menu-content {
  height: 0;
  overflow-y: hidden;
  transition: padding-bottom 0.5s, padding-top 0.5s; /*閉じるときのアニメーション*/
  -webkit-transition: padding-bottom 0.5s, padding-top 0.5s;
  -moz-transition: padding-bottom 0.5s, padding-top 0.5s;
  -ms-transition: padding-bottom 0.5s, padding-top 0.5s;
  -o-transition: padding-bottom 0.5s, padding-top 0.5s;
}
#menu_bar01:checked ~ #links01,
#menu_bar02:checked ~ #links02 {
  height: auto; /*開いたときに表示されるliの高さ*/
  opacity: 1;
  padding: 10px 0;
}
/*開いたときの下の余白*/
#menu_bar01:checked ~ #links01 li:last-child,
#menu_bar02:checked ~ #links02 li:last-child {
  margin-bottom: 20px;
}
/*閉じた状態の矢印描画*/
.menu label:before {
  content: "";
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 3px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #763fd0;
}
.menu label:after {
  content: "";
  position: absolute;
  margin: auto;
  top: -3px;
  bottom: 0;
  left: 10px;
  width: 10px;
  height: 10px;
  border-top: 3px solid #fff;
  border-right: 3px solid #fff;
  transform: rotate(135deg);
}
/*開いた状態の矢印描画*/
.menu input[type="checkbox"]:checked + label:after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-top: #fff 2px solid;
  border-right: #fff 2px solid;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  right: 2%;
  top: 7%;
  bottom: 0;
  margin: auto;
}
/*inputを非表示*/
input[type="checkbox"].on-off {
  opacity: 0;
}

// 用語集テーブルのスタイル （/glossaries からコピー）
.gls-tbl{
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead {text-align: center;}
  tbody {text-align: center;}
}
.aimodel-tbl{
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead {text-align: center;}
  tbody {text-align: center;}
}
.th--gls-name{width: 20%;}
.th--language-pair{width: 6rem;}
.th--gls-remark{}
.th--number{width: 6rem;}
.th--user-name{width: 7rem;}
.th--date{width: 7rem;}
.td--gls-name{
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.td--gls-remark{
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

// Tableのカラムの幅、セルの揃え (モーダルの選択テーブルも含む)
.th--aimodel-name{ width: 20%; }
.th--number{ width: 6rem; }
.td--aimodel-name{ text-align: left; }
.tr--trainable > td{ background: #E4D8F5; }

// [Attention-tooltip: 古いバージョンのAIモデルに対する注意文]
.attention-tooltip{
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.attention-tooltip__description {
    display: none;
    position: absolute;
    padding: 10px;
    font-size: 12px;
    line-height: 1.6em;
    border-radius: 5px;
    color: #fff;
    background: #222;
    width: 300px;
}
.attention-tooltip:hover .attention-tooltip__description{
  display: inline-block;
  top: -120px;
  left: 0px;
}
.attention-tooltip__description:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 10%;
  border: 15px solid transparent;
  border-top: 15px solid #222;
  margin-left: -15px;
}
.attention-tooltip__img {
  margin-bottom: 1px;
  margin-right: 3px;
  width: 20px;
}





// [aimodel-head: 一覧表示の上の行（タブと予約ボタン）のスタイル] 
.aimodel-head {
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 1rem 0;
  height:2rem;
}
.aimodel-tab{
  display: flex;
  justify-content: start;
  align-items: center;
  margin: 1rem 0;
}
.aimodel-tab__item {
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 8rem;

  display: flex;
  align-items: center;
  text-align: center;
  
  text-decoration: none;
  color: black;

  transition-duration: .25s;
  position: relative;
  border-bottom: 1px solid #c8c2c6;
}
.aimodel-tab__item:hover {
  background-color: #F2EDEA;
}
.aimodel-tab__item--selected {
  background-color: #F2EDEA;
  border-bottom: 2px solid #763FD0;
}


</style>
